// Helpers puros/quase-puros extraídos de PublicMenu.js (comportamento VERBATIM).
import { toast } from 'sonner';

export const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

// 📲 Abrir WhatsApp de forma compatível com iOS e Android
export const openWhatsApp = (phoneNumber, message) => {
  if (!phoneNumber) {
    toast.error('Número do restaurante não configurado');
    return;
  }

  const cleanPhone = phoneNumber.replace(/\D/g, '');
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodedMessage}`;

  // Em dispositivos móveis, window.location.href funciona melhor
  // window.open pode ser bloqueado pelo navegador
  window.location.href = whatsappUrl;
};

// 🔄 Compara arrays de produtos/categorias por uma "assinatura" leve para
// detectar mudanças reais (id, nome, preço, image_url). Evita re-render
// desnecessário quando nada mudou E evita o oposto (não atualizar quando
// imagem/preço foi editado mas os IDs são os mesmos).
export const arraysAreEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  const idsJoin = (v, key) => Array.isArray(v)
    ? [...v].map(x => (x && typeof x === 'object') ? (x[key] ?? x.id ?? JSON.stringify(x)) : x).sort().join(',')
    : '';
  const nestedAddons = (v) => Array.isArray(v)
    ? [...v].map(a => `${a.id}:${a.name || ''}:${a.price ?? ''}:${a.available ?? ''}:${idsJoin(a.group_ids, 'id') || (a.group_id ?? '')}`).sort().join(',')
    : '';
  const sigOf = (item) => {
    const base = `${item.id}|${item.name || ''}|${item.price ?? ''}|${item.image_url || ''}|${item.available ?? ''}|${item.promotional_price ?? ''}`;
    const prodGroups = idsJoin(item.additional_groups, 'id');
    const groupMeta = `${item.min_choices ?? ''}|${item.max_choices ?? ''}|${item.is_required ?? ''}|${item.limit_one_per_item ?? ''}|${item.active ?? ''}`;
    const nested = nestedAddons(item.additionals);
    const addonGroups = idsJoin(item.group_ids, 'id') || (item.group_id ?? '');
    return `${base}||${prodGroups}||${groupMeta}||${nested}||${addonGroups}`;
  };
  const sig1 = arr1.map(sigOf).sort().join('@');
  const sig2 = arr2.map(sigOf).sort().join('@');
  return sig1 === sig2;
};

// Function to get next opening time
export const getNextOpeningInfo = (restaurant) => {
  if (!restaurant?.status?.schedule) return null;

  const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const dayNames = {
    sunday: 'Domingo',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado'
  };

  const now = new Date();
  const currentDay = daysOfWeek[now.getDay()];
  const currentTime = now.getHours() * 60 + now.getMinutes();

  // Check today's schedule first
  const todaySchedule = restaurant.status.schedule[currentDay];
  if (todaySchedule?.enabled) {
    const [openHour, openMin] = todaySchedule.open.split(':').map(Number);
    const openTime = openHour * 60 + openMin;

    if (currentTime < openTime) {
      return {
        day: 'hoje',
        time: todaySchedule.open,
        fullDay: dayNames[currentDay]
      };
    }
  }

  // Check next 7 days
  for (let i = 1; i <= 7; i++) {
    const checkDayIndex = (now.getDay() + i) % 7;
    const checkDay = daysOfWeek[checkDayIndex];
    const schedule = restaurant.status.schedule[checkDay];

    if (schedule?.enabled) {
      const dayLabel = i === 1 ? 'amanhã' : dayNames[checkDay];
      return {
        day: dayLabel,
        time: schedule.open,
        fullDay: dayNames[checkDay]
      };
    }
  }

  return null;
};
